
import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


import { ServiceBase } from '@app/services/base.service';
import { AtoProcessual } from '@app/models/ato-processual.model';

@Injectable()
export class AtoProcessualService extends ServiceBase {
  constructor(private http: HttpClient) {
    super();
  }

  gravar(atoProcessual: AtoProcessual): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'configuracoes/atoProcessual', atoProcessual).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  deletar(id: number): Observable<any> {
    return this.http
      .delete<any>(this.URL_API + `configuracoes/atoProcessual/${id}`).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  obterPorId(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `configuracoes/atoProcessual/${id}`, { headers: { meta: ['search'] }});
  }

  obterLista(descricao: string, pagina: number): Observable<any> {
    descricao = encodeURIComponent(descricao);
    return this.http
      .get<any>(this.URL_API + `configuracoes/atoProcessual/lista/?descricao=${descricao}&pagina=${pagina}`, { headers: { meta: ['search'] }});
  }

  // obterTodos() {
  //   return this.http.get(this.URL_API + `atoProcessual`)
  //     .map((res: Response) => res.json());
  // }
}
